import { render, staticRenderFns } from "./SDKMessage_4_2.vue?vue&type=template&id=9c2a02e6"
import script from "./SDKMessage_4_2.vue?vue&type=script&lang=js"
export * from "./SDKMessage_4_2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports